import {
  RECEIVED_SONVI_LIST,
  RECEIVED_SONVI_ELEMENT,
  FILTER_BY_MAIN_CATEGORY,
  // CHANGE_CURRENT_CATEGORIES,
  RESET_CURRENT_CATEGORIES,
  FILTER_BY_SOUND,
  UPDATE_FILTERED_LIST,
} from "../actions/elements";
// import { getClassName, getDescripction } from "../../utils/categories";
const initState = {
  sonviList: [],
  filteredList: [],
  sonviObject: {},
  currentCategories: [],
};

export default function sonvi(
  state = initState,
  action = {
    payload: {
      sonviList: [],
      sonviObject: {},
      mainCategory: "",
      soundCategory: "",
    },
  }
) {
  if (action.payload) {
    var { sonviList, sonviObject, bounds } = action.payload;
  }

  switch (action.type) {
    case RECEIVED_SONVI_LIST:
      return { ...state, sonviList, filteredList: sonviList };
    case RECEIVED_SONVI_ELEMENT:
      return { ...state, sonviObject };
    case UPDATE_FILTERED_LIST:
      const {
        lngMin = -200,
        lngMax = 200,
        latMin = -200,
        latMax = 200,
      } = bounds;
      const filterBounds = state.sonviList?.filter(({ lat, lng }) => {
        return latMin <= lat && lat <= latMax && lngMin <= lng && lng <= lngMax;
      });
      return { ...state, sonviObject, filteredList: filterBounds };
    // case RESET_CURRENT_CATEGORIES:
    //   const categories = state.sonviList.map((element) => {
    //     // const cat = getClassName(element.category);
    //     // const desc = getDescripction(element.category);

    //     // return { name: desc, category: cat };
    //     return state;
    //   });
    //   const currentCategories = categories.filter((thing, index) => {
    //     const _thing = JSON.stringify(thing);
    //     return (
    //       index ===
    //       categories.findIndex((obj) => {
    //         return JSON.stringify(obj) === _thing;
    //       })
    //     );
    //   });
    //   currentCategories.sort((a, b) => {
    //     return a.name < b.name ? -1 : a.name > b.name ? 1 : 0;
    //   });
    //   return { ...state, currentCategories };
    // case FILTER_BY_MAIN_CATEGORY:
    //   const filteredList = state.sonviList.filter((elem) => {
    //     if (mainCategory === "Todos") return true;
    //     // return getClassName(elem.category) === mainCategory;
    //   });
    //   const categoriesList = state.currentCategories.filter((elem) => {
    //     if (mainCategory === "Todos") return true;
    //     return elem.category === mainCategory;
    //   });

    //   return {
    //     ...state,
    //     filteredList,
    //     currentCategories: categoriesList,
    //   };
    // case FILTER_BY_SOUND:
    //   const filtered = state.filteredList.filter((elem) => {
    //     if (soundCategory === undefined) return true;
    //     // return getDescripction(elem.category) === soundCategory;
    //     return state;
    //   });

    //   return {
    //     ...state,
    //     filteredList: filtered,
    //   };
    default:
      return state;
  }
}
